import { Layout } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { PageContentLayoutViewProps } from './PageContentLayoutViewProps';

const StyledMain = styled.main`
  margin-top: ${(props) => props.theme.size.dynamic0100};
  margin-bottom: ${(props) => props.theme.size.dynamic0250};
`;

export function PageContentLayoutVwView({ children }: PageContentLayoutViewProps): ReactElement {
  return (
    <StyledMain>
      <Layout allowOverflowingContent>{children}</Layout>
    </StyledMain>
  );
}
